var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-link"},[_c('div',{staticClass:"right"},[_c('div',{staticClass:"item",class:{
        active:
          _vm.path.indexOf('newsDetails') == -1 &&
          _vm.path.indexOf(_vm.arr[0].link) !== -1,
      },on:{"click":function($event){return _vm.linkTo(_vm.arr[0])}}},[_c('span',[_vm._v(_vm._s(_vm.arr[0].title))])]),(
        _vm.exhibitionConfig &&
        _vm.exhibitionConfig.feature &&
        _vm.exhibitionConfig.feature.enabledSupplyDemand
      )?_c('div',{staticClass:"item",class:{
        active:
          _vm.path.indexOf('newsDetails') == -1 &&
          _vm.path.indexOf(_vm.arr[1].link) !== -1,
      },on:{"click":function($event){return _vm.linkTo(_vm.arr[1])}}},[_c('span',[_vm._v(_vm._s(_vm.arr[1].title))])]):_vm._e(),_c('div',{staticClass:"item",class:{
        active:
          _vm.path.indexOf('newsDetails') == -1 &&
          _vm.path.indexOf(_vm.arr[2].link) !== -1,
      },on:{"click":function($event){return _vm.linkTo(_vm.arr[2])}}},[_c('span',[_vm._v(_vm._s(_vm.arr[2].title))])]),_c('div',{staticClass:"item",class:{
        active:
          _vm.path.indexOf('newsDetails') == -1 &&
          _vm.path.indexOf(_vm.arr[3].link) !== -1,
      },on:{"click":function($event){return _vm.linkTo(_vm.arr[3])}}},[_c('span',[_vm._v(_vm._s(_vm.arr[3].title))])]),(false)?_c('div',{staticClass:"item",class:{
        active:
          _vm.path.indexOf('newsDetails') == -1 &&
          _vm.path.indexOf(_vm.arr[5].link) !== -1,
      },on:{"click":function($event){return _vm.linkTo(_vm.arr[5])}}},[_c('span',[_vm._v(_vm._s(_vm.arr[5].title))])]):_vm._e(),(
        _vm.exhibitionConfig &&
        _vm.exhibitionConfig.feature &&
        _vm.exhibitionConfig.feature.enabledArticle &&
        false
      )?_c('div',{staticClass:"item",class:{
        active:
          _vm.path.indexOf('newsDetails') == -1 &&
          _vm.path.indexOf(_vm.arr[6].link) !== -1,
      },on:{"click":function($event){return _vm.linkTo(_vm.arr[6])}}},[_c('span',[_vm._v(_vm._s(_vm.arr[6].title))])]):_vm._e(),(
        _vm.exhibitionConfig &&
        _vm.exhibitionConfig.feature &&
        _vm.exhibitionConfig.feature.enabledExhibitionSurvey &&
        false
      )?_c('div',{staticClass:"item",class:{
        active:
          _vm.path.indexOf('newsDetails') == -1 &&
          _vm.path.indexOf(_vm.arr[7].link) !== -1,
      },on:{"click":function($event){return _vm.linkTo(_vm.arr[7])}}},[(_vm.exhibitionId === '6d9aa6f0-aa0b-4523-9b16-6ee8307b628c')?[_vm._v(" 关于FIBO ")]:[_c('span',[_vm._v(_vm._s(_vm.arr[7].title))])]],2):_vm._e(),_c('div',{staticClass:"item",class:{
        active:
          _vm.path.indexOf('newsDetails') == -1 &&
          _vm.path.indexOf(_vm.arr[8].link) !== -1,
      },on:{"click":function($event){return _vm.linkTo(_vm.arr[8])}}},[_c('span',[_vm._v(_vm._s(_vm.arr[8].title))])]),_c('div',{staticClass:"item",on:{"click":function($event){return _vm.linkToSite(_vm.arr[9])}}},[_c('span',[_vm._v(_vm._s(_vm.arr[9].title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }